module.exports = __webpack_public_path__ + "img/joinStraightWhite.8ead4507.svg";